const USER_MANAGEMENT_EXPERIENCE_TYPES = {
  CREATE: '[userManagementExperience] createUser',
  SET_CREATED: '[userManagementExperience] setCreated',
  EDIT: '[userManagementExperience] editUser',
  CHANGE_PASSWORD: '[userManagementExperience] changeUserPassword',
  PATCH_POLICY: '[userManagementExperience] patchUserPolicy',
  PATCH_PHOTO: '[userManagementExperience] patchUserPhoto',
  UPDATE_ATTRIBUTE_ACTIVE: '[userManagementExperience] updateUserAttributeActive',
  DELETE: '[userManagementExperience] deleteUser'
}

export default USER_MANAGEMENT_EXPERIENCE_TYPES
